 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"canvg":"canvg","communication-Components-communication-communication-module":"communication-Components-communication-communication-module","communication-Components-communication-trigger-communication-trigger-module":"communication-Components-communication-trigger-communication-trigger-module","dashboard-mysteryshopper-mysteryshopper-module":"dashboard-mysteryshopper-mysteryshopper-module","default~loyalty-Components-content-learning-content-learning-module~loyalty-Components-loyalty-banne~b3da6d5a":"default~loyalty-Components-content-learning-content-learning-module~loyalty-Components-loyalty-banne~b3da6d5a","common":"common","menu-programs-menu-program-menu-program-module":"menu-programs-menu-program-menu-program-module","settings-Components-campaign-campaign-module":"settings-Components-campaign-campaign-module","visibity-Components-posm-posm-module":"visibity-Components-posm-posm-module","default~loyalty-Components-loyalty-banners-loyalty-banners-module~loyalty-Components-point-structure~9cdf1fe8":"default~loyalty-Components-loyalty-banners-loyalty-banners-module~loyalty-Components-point-structure~9cdf1fe8","loyalty-Components-schemes-offers-schemes-offers-module":"loyalty-Components-schemes-offers-schemes-offers-module","loyalty-Components-whitelist-outlets-whitelist-outlets-module":"loyalty-Components-whitelist-outlets-whitelist-outlets-module","mystery-Components-assign-mystery-shopper-assign-mystery-shopper-module":"mystery-Components-assign-mystery-shopper-assign-mystery-shopper-module","mystery-Components-mystery-audit-template-mystery-audit-template-module":"mystery-Components-mystery-audit-template-mystery-audit-template-module","tertiary-programs-carton-insert-carton-insert-module":"tertiary-programs-carton-insert-carton-insert-module","tertiary-programs-crown-collections-crown-collections-module":"tertiary-programs-crown-collections-crown-collections-module","loyalty-Components-loyalty-banners-loyalty-banners-module":"loyalty-Components-loyalty-banners-loyalty-banners-module","loyalty-Components-point-structure-point-structure-module":"loyalty-Components-point-structure-point-structure-module","mystery-Components-add-mystery-shopper-add-mystery-shopper-module":"mystery-Components-add-mystery-shopper-add-mystery-shopper-module","loyalty-Components-content-learning-content-learning-module":"loyalty-Components-content-learning-content-learning-module","mystery-Components-mystery-whitelist-mystery-whitelist-module":"mystery-Components-mystery-whitelist-mystery-whitelist-module","settings-Components-add-user-add-user-module":"settings-Components-add-user-add-user-module","default~mystery-Components-mystery-qc-mystery-qc-module~mystery-Components-qc-report-qc-report-module":"default~mystery-Components-mystery-qc-mystery-qc-module~mystery-Components-qc-report-qc-report-module","mystery-Components-mystery-qc-mystery-qc-module":"mystery-Components-mystery-qc-mystery-qc-module","mystery-Components-qc-report-qc-report-module":"mystery-Components-qc-report-qc-report-module","dompurify":"dompurify","login-login-module":"login-login-module","logout-logout-module":"logout-logout-module","menu-programs-menu-brand-template-menu-brand-template-module":"menu-programs-menu-brand-template-menu-brand-template-module","menu-programs-menu-program-config-menu-program-config-module":"menu-programs-menu-program-config-menu-program-config-module","menu-programs-menu-program-overview-menu-program-overview-module":"menu-programs-menu-program-overview-menu-program-overview-module","rewards-reward-report-reward-report-module":"rewards-reward-report-reward-report-module","settings-Components-campaign-test-campaign-test-module":"settings-Components-campaign-test-campaign-test-module","settings-Components-geographical-hierarchy-geographical-hierarchy-module":"settings-Components-geographical-hierarchy-geographical-hierarchy-module","settings-Components-leaderboard-leaderboard-module":"settings-Components-leaderboard-leaderboard-module","settings-Components-outlet-hierarchy-outlet-hierarchy-module":"settings-Components-outlet-hierarchy-outlet-hierarchy-module","settings-Components-user-profile-user-profile-module":"settings-Components-user-profile-user-profile-module"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
